'use client';

import { useModals } from '@/contexts/ModalContext';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useCallback } from 'react';
import { SetPhoneModal } from './SetPhoneModal';

type Props = {
  onOk: () => void;
};

export const MakeSetPhoneModal: React.FC<Props> = ({ onOk }) => {
  const modals = useModals();
  const t = useTranslations('modals');

  const onClose = () => {
    onOk();
    modals.close(`make-set-phone`);
  };

  const openSetPhone = useCallback(() => {
    modals.close(`make-set-phone`);
    modals.open(
      'set-phone-modal',
      <SetPhoneModal />,
      true,
      'md:h-unset h-unset absolute md:static bottom-0 rounded-b-none md:rounded-b-[24px] m-0',
    );
  }, [modals]);

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <Image
          src='/assets/images/set-phone-popup.webp'
          width={120}
          height={120}
          alt=''
          className='justify-self-center self-center'
        />

        <DialogHeader className='items-center text-center'>
          <DialogTitle>{t('makeSetPhoneModal.header')}</DialogTitle>
          <DialogDescription>{t('makeSetPhoneModal.text')}</DialogDescription>
        </DialogHeader>

        <Button
          variant='outline'
          onClick={openSetPhone}
          className='w-full h-[44px] rounded-[12px] bg-transparent hover:bg-transparent border-primary-green-day'
        >
          {t('makeSetPhoneModal.btn')}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
